var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "ops-section" },
    [
      _c(
        "el-card",
        { staticClass: "ops-page", attrs: { shadow: "never" } },
        [
          _c(
            "div",
            {
              staticClass: "ops-header",
              attrs: { slot: "header" },
              slot: "header",
            },
            [
              _c("i", { staticClass: "el-icon-setting" }),
              _vm._v(" "),
              _c("span", [_vm._v("卷广场设置")]),
            ]
          ),
          _vm._v(" "),
          _c(
            "el-form",
            {
              ref: "opsForm",
              staticClass: "ops-form",
              attrs: { model: _vm.form, "label-width": "150px" },
            },
            [
              _c(
                "el-card",
                { staticClass: "ops-block", attrs: { shadow: "never" } },
                [
                  _c(
                    "div",
                    {
                      staticClass: "block-title",
                      attrs: { slot: "header" },
                      slot: "header",
                    },
                    [_vm._v("基础门槛设置")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    { attrs: { gutter: 16 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "消费金额标准" } },
                            [
                              _c("el-input-number", {
                                attrs: { min: 0, max: 999999, size: "mini" },
                                model: {
                                  value: _vm.form.base.consumeAmount,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.form.base,
                                      "consumeAmount",
                                      $$v
                                    )
                                  },
                                  expression: "form.base.consumeAmount",
                                },
                              }),
                              _vm._v(" "),
                              _c("span", { staticClass: "ml8" }, [
                                _vm._v(">= 元"),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "优惠券超时回退" } },
                            [
                              _c("el-input-number", {
                                attrs: { min: 0, max: 240, size: "mini" },
                                model: {
                                  value: _vm.form.base.timeoutHours,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form.base, "timeoutHours", $$v)
                                  },
                                  expression: "form.base.timeoutHours",
                                },
                              }),
                              _vm._v(" "),
                              _c("span", { staticClass: "ml8" }, [
                                _vm._v("小时"),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-card",
                { staticClass: "ops-block", attrs: { shadow: "never" } },
                [
                  _c(
                    "div",
                    {
                      staticClass: "block-title",
                      attrs: { slot: "header" },
                      slot: "header",
                    },
                    [_vm._v("券广场核心规则")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    { attrs: { gutter: 16 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "券广场发券规则" } },
                            [
                              _c("el-input", {
                                attrs: {
                                  type: "textarea",
                                  rows: 4,
                                  placeholder: "请输入规则说明",
                                },
                                model: {
                                  value: _vm.form.rules.square,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form.rules, "square", $$v)
                                  },
                                  expression: "form.rules.square",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "官方券等发券规则" } },
                            [
                              _c("el-input", {
                                attrs: {
                                  type: "textarea",
                                  rows: 4,
                                  placeholder: "请输入规则说明",
                                },
                                model: {
                                  value: _vm.form.rules.official,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form.rules, "official", $$v)
                                  },
                                  expression: "form.rules.official",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-card",
                { staticClass: "ops-block", attrs: { shadow: "never" } },
                [
                  _c(
                    "div",
                    {
                      staticClass: "block-title",
                      attrs: { slot: "header" },
                      slot: "header",
                    },
                    [_vm._v("券广场辅助配置")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    { attrs: { gutter: 16 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "提交热词" } },
                            [
                              _c("el-input", {
                                attrs: { placeholder: "85折, 免单, 买一赠一" },
                                model: {
                                  value: _vm.form.assist.hotWords,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form.assist, "hotWords", $$v)
                                  },
                                  expression: "form.assist.hotWords",
                                },
                              }),
                              _vm._v(" "),
                              _c("div", { staticClass: "form-tip" }, [
                                _vm._v("*，每个词汇之间请用中文逗号分割"),
                              ]),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            { attrs: { label: "券广场分享词" } },
                            [
                              _c("el-input", {
                                attrs: {
                                  type: "textarea",
                                  rows: 3,
                                  placeholder: "请输入",
                                },
                                model: {
                                  value: _vm.form.assist.shareText,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form.assist, "shareText", $$v)
                                  },
                                  expression: "form.assist.shareText",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "券广场分享图" } },
                            [
                              _c(
                                "el-upload",
                                {
                                  attrs: {
                                    action: "#",
                                    "list-type": "picture-card",
                                    limit: 1,
                                    "auto-upload": false,
                                    "on-exceed": _vm.onExceed,
                                    "file-list": _vm.form.assist.shareImages,
                                    "on-preview": _vm.handlePictureCardPreview,
                                    "on-remove": _vm.handleShareRemove,
                                    "on-change": _vm.handleShareChange,
                                    "before-upload": _vm.beforeUpload,
                                    accept: "image/*",
                                  },
                                },
                                [
                                  _c("i", { staticClass: "el-icon-plus" }),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "el-upload__tip",
                                      attrs: { slot: "tip" },
                                      slot: "tip",
                                    },
                                    [_vm._v("只能上传jpg/png文件，且不超过2MB")]
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "el-dialog",
                                {
                                  attrs: {
                                    visible: _vm.dialogVisible,
                                    size: "tiny",
                                  },
                                  on: {
                                    "update:visible": function ($event) {
                                      _vm.dialogVisible = $event
                                    },
                                  },
                                },
                                [
                                  _c("img", {
                                    attrs: {
                                      width: "100%",
                                      src: _vm.dialogImageUrl,
                                      alt: "",
                                    },
                                  }),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-card",
                { staticClass: "ops-block", attrs: { shadow: "never" } },
                [
                  _c(
                    "div",
                    {
                      staticClass: "block-title",
                      attrs: { slot: "header" },
                      slot: "header",
                    },
                    [_vm._v("会员等级限制详情")]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "sub-title" }, [
                    _vm._v("普通券每日发券限制"),
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-table",
                    {
                      staticClass: "mb16",
                      attrs: {
                        data: _vm.limitTables.dailySendNormal,
                        border: "",
                        size: "mini",
                      },
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          prop: "label",
                          label: "会员等级",
                          width: "100",
                        },
                      }),
                      _vm._v(" "),
                      _vm._l(_vm.memberCols, function (col) {
                        return _c("el-table-column", {
                          key: col.prop,
                          attrs: { label: col.label, align: "center" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c("el-input-number", {
                                      attrs: { min: 0, max: 999, size: "mini" },
                                      model: {
                                        value: scope.row[col.prop],
                                        callback: function ($$v) {
                                          _vm.$set(scope.row, col.prop, $$v)
                                        },
                                        expression: "scope.row[col.prop]",
                                      },
                                    }),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      }),
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "sub-title" }, [
                    _vm._v("普通券每月发券限制"),
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-table",
                    {
                      staticClass: "mb16",
                      attrs: {
                        data: _vm.limitTables.monthlySendNormal,
                        border: "",
                        size: "mini",
                      },
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          prop: "label",
                          label: "会员等级",
                          width: "100",
                        },
                      }),
                      _vm._v(" "),
                      _vm._l(_vm.memberCols, function (col) {
                        return _c("el-table-column", {
                          key: col.prop,
                          attrs: { label: col.label, align: "center" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c("el-input-number", {
                                      attrs: { min: 0, max: 999, size: "mini" },
                                      model: {
                                        value: scope.row[col.prop],
                                        callback: function ($$v) {
                                          _vm.$set(scope.row, col.prop, $$v)
                                        },
                                        expression: "scope.row[col.prop]",
                                      },
                                    }),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      }),
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "sub-title" }, [
                    _vm._v("普通券每日领券限制（单用户）"),
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-table",
                    {
                      staticClass: "mb16",
                      attrs: {
                        data: _vm.limitTables.dailyReceivePerUser,
                        border: "",
                        size: "mini",
                      },
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          prop: "label",
                          label: "会员等级",
                          width: "100",
                        },
                      }),
                      _vm._v(" "),
                      _vm._l(_vm.memberCols, function (col) {
                        return _c("el-table-column", {
                          key: col.prop,
                          attrs: { label: col.label, align: "center" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c("el-input-number", {
                                      attrs: { min: 0, max: 999, size: "mini" },
                                      model: {
                                        value: scope.row[col.prop],
                                        callback: function ($$v) {
                                          _vm.$set(scope.row, col.prop, $$v)
                                        },
                                        expression: "scope.row[col.prop]",
                                      },
                                    }),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      }),
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "sub-title" }, [
                    _vm._v("普通券+官方券每日领券限制（总次数）"),
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-table",
                    {
                      staticClass: "mb16",
                      attrs: {
                        data: _vm.limitTables.dailyReceiveTotal,
                        border: "",
                        size: "mini",
                      },
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          prop: "label",
                          label: "会员等级",
                          width: "100",
                        },
                      }),
                      _vm._v(" "),
                      _vm._l(_vm.memberCols, function (col) {
                        return _c("el-table-column", {
                          key: col.prop,
                          attrs: { label: col.label, align: "center" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c("el-input-number", {
                                      attrs: { min: 0, max: 999, size: "mini" },
                                      model: {
                                        value: scope.row[col.prop],
                                        callback: function ($$v) {
                                          _vm.$set(scope.row, col.prop, $$v)
                                        },
                                        expression: "scope.row[col.prop]",
                                      },
                                    }),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      }),
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "sub-title" }, [
                    _vm._v("官方券每日领券限制"),
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-table",
                    {
                      staticClass: "mb16",
                      attrs: {
                        data: _vm.limitTables.dailyReceiveOfficial,
                        border: "",
                        size: "mini",
                      },
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          prop: "label",
                          label: "会员等级",
                          width: "100",
                        },
                      }),
                      _vm._v(" "),
                      _vm._l(_vm.memberCols, function (col) {
                        return _c("el-table-column", {
                          key: col.prop,
                          attrs: { label: col.label, align: "center" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c("el-input-number", {
                                      attrs: { min: 0, max: 999, size: "mini" },
                                      model: {
                                        value: scope.row[col.prop],
                                        callback: function ($$v) {
                                          _vm.$set(scope.row, col.prop, $$v)
                                        },
                                        expression: "scope.row[col.prop]",
                                      },
                                    }),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      }),
                    ],
                    2
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "ops-actions" },
                [
                  _c("el-button", { on: { click: _vm.onReset } }, [
                    _vm._v("重置"),
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    { attrs: { type: "primary" }, on: { click: _vm.onSubmit } },
                    [_vm._v("确认")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }